<template>
    <div class="djzx">
        <!-- 头部 -->
        <navbar-header></navbar-header>
        <!-- 背景 -->
        <!-- 背景层 -->
        <div class="bg_box">
        </div>

        <!-- 轮播和新闻列表 -->
        <swiper-news></swiper-news>

        <!-- 3张图片 -->
        <div class="img_box">
            <div class="img_item hvr-grow" v-for="(item, index) in imgList" :key="index">
                <a :href="item.ads_link" target="_blank">
                    <img :src="item.ads_img" v-if="item.ads_img && item.ads_img.indexOf('http') != -1" alt="">
                    <img :src="$ImgUrl + item.ads_img" v-if="item.ads_img && item.ads_img.indexOf('http') == -1" alt="">
                </a>
            </div>
        </div>

        <!-- tab -->
        <news-tab></news-tab>

        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
import NavbarHeader from '@/components/index/NavbarHeader'
import NavFooter from '@/components/common/NavFooter'
import SwiperNews from '@/components/djzx/SwiperNews'
import NewsTab from '@/components/djzx/NewsTab'
    export default {
        components: {
            NavbarHeader,
            SwiperNews,
            NewsTab,
            NavFooter
        },
        data() {
            return {
                imgList: [],
            }
        },
        mounted () {
            this.getImgList();
        },
        methods: {
            // 获取图片
            async getImgList() {
                let res = await this.$axios.post("/lencon/pc/index/banner", { type: 6 })
                if ( res.data.code == 1 ) {
                    this.imgList = res.data.res
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.djzx {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 300px;
        z-index: -1;
    }
}
.img_box {
    width: 1200px;
    margin: 30px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img_item {
        width: 371px;
        height: 94px;
        background-color: #fff;
    }
}
</style>